<template>
  <div class="text-center">
    <div class="row mr-1 mr-md-0">
      <div class="col-12">
        <button class="close" @click="close()">
          <font-awesome-icon icon="times" />
        </button>
      </div>
    </div>
    <div class="row m-1">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-12">
            <h3>What do you need to do?</h3>
          </div>
          <div class="col-md-12 col-12 p-3 cp mb-4">
            <a @click="onAppUrlClick(cpTitle,cpUrl)" :href="cpUrl">
              <div class="row text-left d-flex flex-wrap align-items-center">
                <div class="col-12 col-md-3">
                  <div class="panel-change">
                    <div class="panel-icon mx-auto d-block"></div>
                  </div>
                </div>
                <div class="col-12 col-md-9">
                  <h4>I want to change my password.</h4>
                  <p
                    class="pw-title"
                  >For security, all Autodesk employees must change their password every 90 days. If you know your current password, you can change it once every 24 hours.</p>
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-12 col-12 rp p-3">
            <a @click="onAppUrlClick(rpTitle,rpUrl)" :href="rpUrl">
              <div class="row text-left d-flex flex-wrap align-items-center">
                <div class="col-md-3 col-12">
                  <div class="panel-reset">
                    <div class="panel-icon mx-auto d-block"></div>
                  </div>
                </div>
                <div class="col-md-9 col-12">
                  <h4>I forgot my password.</h4>
                  <p class="pw-title">
                    If you can't remember your
                    password, you can reset it using Employee Hub. Please note, this will
                    only work if you have Two-Step Verification (Duo) enabled. If you
                    need assistance, or if you are an Autodesk Associate, please
                    contact the Enterprise Service Desk, +1 415-507-8888.
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MixpanelMixin from "@/mixins/MixpanelMixin";
export default {
  name: "HelloModal.vue",
  props: ["propData"],
  mixins: [MixpanelMixin],
  data() {
    return {
      cpTitle: "Change Password",
      cpUrl: "https://changepassword.helphub.autodesk.com",
      rpTitle: "Reset Password",
      rpUrl: "https://resetpassword.helphub.autodesk.com"
    };
  },
  methods: {
    onAppUrlClick(title, url) {
      this.trackEvent(document.title, {
        subEvent: title,
        subEventUrl: url
      });

      return true;
    },
    close() {
      this.$emit("close");
    },
    submit() {
      this.close();
    }
  }
};
</script>

<style scoped>
.cp {
  background: linear-gradient(to right, #32dcb2 0%, #32bcad 100%);
  color: #fff;
}

.rp {
  background: linear-gradient(to right, #87d540 0%, #87bc40 100%);
  color: #fff;
}

.panel-change .panel-icon {
  background: url(../assets/images/change_password_logo.png) center center
    no-repeat;
}

.panel-reset .panel-icon {
  background: url(../assets/images/reset_password_logo.png) center center
    no-repeat;
}

.panel-icon {
  height: 86px;
  width: 86px;
}

.pw-title {
  font-size: 14px;
}

.cp a {
  color: #fff;
  text-decoration: none;
}

.rp a {
  color: #fff;
  text-decoration: none;
}
</style>
